import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=1a53c5ea&"
import script from "./LoaderOverlay.vue?vue&type=script&lang=ts&"
export * from "./LoaderOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./LoaderOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports